import React, { useEffect } from 'react';
import { Button, Typography, Popover, theme, Menu } from 'antd';
import {
  MessageOutlined,
  StarOutlined,
  LinkOutlined,
  CalendarOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';

import { useEvent } from '../events/hooks/useEvent';
import { HubSpot } from './';
import { useUserSnap } from './UserSnap';
import ContactSalesModal from './ContactSalesModal';
import { TOOLTIP_ROOT_ID } from '../../components/Tooltip';

const HELP_CENTER_URL = 'https://docs.prerender.io/';
export const EVENTS_TRACKED = {
  sectionOpened: 'Help section opened',
  helpCenterClicked: 'Help Center clicked',
  contactSupportClicked: 'Contact support clicked',
  contactSalesClicked: 'Contact sales clicked',
  submitFeedbackClicked: 'Submit feedback clicked',
};

function HelpSection({ eventsTrackingData = {} }) {
  const [isHelpPopoverOpen, setIsHelpPopoverOpen] = React.useState(false);
  const [isContactSalesModalOpen, setIsContactSalesModalOpen] = React.useState(false);
  const [selectedKeys, setSelectedKeys] = React.useState([]);
  const { openSubmitFeedbackWidget } = useUserSnap();
  const { track } = useEvent();
  const { token } = theme.useToken();

  const actionWrapper = (callback, eventName) => () => {
    track(eventName, eventsTrackingData);
    callback();
    setIsHelpPopoverOpen(false);
  };

  const onHelpClick = () => {
    track(EVENTS_TRACKED.sectionOpened, eventsTrackingData);
    setIsHelpPopoverOpen(true);
  };

  useEffect(() => {
    if (!isHelpPopoverOpen) {
      setSelectedKeys([]);
    }
  }, [isHelpPopoverOpen]);

  const menuItems = [
    {
      key: 'support',
      icon: <MessageOutlined />,
      label: 'Contact Support',
      onClick: actionWrapper(() => HubSpot.openHubSpotForm(), EVENTS_TRACKED.contactSupportClicked),
    },
    {
      key: 'docs',
      icon: <LinkOutlined />,
      label: 'Help Docs',
      onClick: actionWrapper(() => window.open(HELP_CENTER_URL, '_blank'), EVENTS_TRACKED.helpCenterClicked),
    },
    {
      key: 'feedback',
      icon: <StarOutlined />,
      label: 'Submit Feedback',
      onClick: actionWrapper(openSubmitFeedbackWidget, EVENTS_TRACKED.submitFeedbackClicked),
    },
    {
      key: 'sales',
      icon: <CalendarOutlined />,
      label: 'Contact Sales',
      onClick: actionWrapper(() => setIsContactSalesModalOpen(true), EVENTS_TRACKED.contactSalesClicked),
    },
  ].filter(Boolean);

  return (
    <>
      <Popover
        title="How can we help you?"
        trigger="click"
        open={isHelpPopoverOpen}
        onOpenChange={(value) => setIsHelpPopoverOpen(value)}
        content={
          <div>
            <Typography.Paragraph>
              <p>Please choose an option below.</p>
            </Typography.Paragraph>
            <Menu
              mode="vertical"
              items={menuItems}
              style={{ border: 'none' }}
              selectedKeys={selectedKeys}
              onSelect={({ key }) => setSelectedKeys([key])}
            />
          </div>
        }
      >
        <Button
          icon={<QuestionCircleOutlined style={{ fontSize: 24 }} />}
          iconPosition="end"
          type="text"
          size="large"
          onClick={onHelpClick}
          data-tooltip-id={TOOLTIP_ROOT_ID}
          data-tooltip-content={'Help'}
          data-tooltip-place="bottom"
          style={{ color: token.colorPrimary }}
        >
          Support
        </Button>
      </Popover>
      <ContactSalesModal
        open={isContactSalesModalOpen}
        onClose={() => setIsContactSalesModalOpen(false)}
        eventsTrackingData={eventsTrackingData}
      />
    </>
  );
}

export default HelpSection;
